import { ApiClientProps } from "hooks/useApi";
import { LocationDetailsProps } from "./getLocationDetails";

export interface Location {
  id: number;
  enabled: boolean;
  lastUpdate?: string;
  locationId: string;
  name: string | null;
  partnerKey: string;
  partnerVenueId: string;
  posType: string;
  apiType: string | null | undefined;
  tableStatusMap?: LocationDetailsProps["tableStatusMap"];
  checkMatchEnabled: boolean;
  partnerId?: string;
}

interface GetLocationsProps {
  partnerId: string | undefined;
  apiClient: ApiClientProps;
}

async function getLocations({
  partnerId,
  apiClient,
}: GetLocationsProps): Promise<Location[] | undefined> {
  try {
    const response = await apiClient.get({
      path: `/middleware-admin/partners/${partnerId}/locations`,
    });

    return response.resource;
  } catch (error) {
    throw new Error("Network request error trying to fetch the locations");
  }
}

export default getLocations;
